// FIXME: set config to api, dev and prod envs
var endpoint = 'https://localhost:3000'
var rootFolder = '/'
var root = document.location.protocol + '//' + document.location.host + rootFolder

switch (document.location.hostname) {
    case 'localhost':
        endpoint = 'http://localhost:3000'
        rootFolder = '/'
        root = document.location.protocol + '//' + document.location.host + rootFolder
        break
    case 'staging.mein-hilo.de':
            endpoint = 'https://staging-api.mein-hilo.de'
            rootFolder = '/'
            root = document.location.protocol + '//' + document.location.host + rootFolder
            break
    case 'mein-hilo.de':
        endpoint = 'https://api.mein-hilo.de'
        rootFolder = '/'
        root = document.location.protocol + '//' + document.location.host + rootFolder
        break
}

// set up jquery ajax client
$.ajaxSetup({
    beforeSend: function (xhr, options) {
        options.url = endpoint + options.url
        // Use unified 'token' from localStorage
        const token = localStorage.getItem('token')
        if (token) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + token)
        }
    }
})
$(document).ajaxError(function (e, xhr, settings) {
    
    console.log('Global AJAX error:', {
        status: xhr.status,
        url: settings.url,
        global: settings.global !== false,
        pathname: window.location.pathname
    })

    // Don't redirect on login page - let login form handle errors
    if (!window.location.pathname.startsWith('/secure/user/')) {
        return;
    }
    // If the user is not logged in, redirect to the login page
    if (xhr.status === 401) {
        console.warn('401 error in global handler - redirecting to login')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        // Cleanup old token keys
        localStorage.removeItem('api')
        localStorage.removeItem('jwt')
        localStorage.removeItem('jwtToken')
        window.location.href = rootFolder
    }
})
// let users re-login, when api answers 401 (mostly token expiration)
// $(document).ajaxError(function (e, xhr) {
//     if (xhr.status === 401) {
//         $.confirm({
//             offsetTop: 20,
//             theme: 'bootstrap',
//             columnClass: 'medium',
//             title: 'Sitzung abgelaufen - Erneut einloggen',
//             content: '<form id="loginform">' +
//                 '<p class="text-center"><img src="/img/logo.png" alt="Logo" /></a></p>' +
//                 '<p id="lgerror" class="alert alert-danger hidden"></p>' +
//                 '<div class="form-group">' +
//                 '    <label for="user"></label>' +
//                 '    <input type="text" class="form-control" id="username" placeholder="Username">' +
//                 '</div>' +
//                 '<div class="form-group">' +
//                 '    <label for="password"></label>' +
//                 '    <input type="password" class="form-control" id="password" placeholder="Passwort">' +
//                 '</div>',
//             buttons: {
//                 cancel: {
//                     text: 'schließen',
//                     btnClass: 'btn-secondary'
//                     // action: function () { }
//                 },
//                 login: {
//                     text: 'einloggen',
//                     btnClass: 'btn-primary',
//                     action: function () {
//                         var that = this
//                         Promise.resolve(login()).then(function () {
//                             // TODO: redo request without refreshing, so we don't lose form input?
//                             window.location.reload()
//                             that.close()
//                         }).catch(function (err) {
//                             $('#lgerror').removeClass('hidden').html(err)
//                         })
//                         return false // prevent modal from closing
//                     }
//                 }
//             }
//         })
//     }
//     if (xhr.status === 403) {
//         $.confirm({
//             offsetTop: 20,
//             theme: 'bootstrap',
//             columnClass: 'medium',
//             title: 'Zugriff verweigert',
//             content: '<p class="text-center">Fehlende Berechtigung zum Zugriff auf diesen Bereich oder diese Aktion.</p>',
//             buttons: {
//                 cancel: {
//                     text: 'schließen',
//                     btnClass: 'btn-primary',
//                     action: function () {
//                         // return to last screen
//                         window.history.back()
//                     }
//                 }
//             }
//         })
//     }
// })

// run scripts on startup
$(function () {

    // redirect if not loggedin and not on loginpage
    const hasToken = localStorage.getItem('token')
    const hasUserData = localStorage.getItem('user')
    
    console.log('Base.js startup check:', {
        hasToken: !!hasToken,
        hasUserData: !!hasUserData,
        isLoginPage: !!$('#loginpage').length,
        pathname: window.location.pathname
    })
    
    // Cleanup: migrate old token structure if needed
    if (localStorage.getItem('api') || localStorage.getItem('jwt') || localStorage.getItem('jwtToken')) {
        console.log('Migrating old token structure...')
        const oldToken = localStorage.getItem('jwt') || localStorage.getItem('api') || localStorage.getItem('jwtToken')
        if (oldToken && !hasToken) {
            localStorage.setItem('token', oldToken)
        }
        localStorage.removeItem('api')
        localStorage.removeItem('jwt')
        localStorage.removeItem('jwtToken')
    }
    
    // User needs token to be logged in (login + legal pages are freely accessible)
    const isPublicPage = $('#loginpage').length || $('#legalpage').length
    // Token-/Mail-Flows: müssen auch mit aktiver Session (Multi-Tab) nutzbar bleiben
    const pathName = window.location.pathname || ''
    const skipLoggedInRedirect =
        pathName.endsWith('email-aenderung-bestaetigen.html') ||
        pathName.endsWith('passwort-anfordern.html')
    if (!isPublicPage && !hasToken) {
        console.warn('No token found, redirecting to login')
        window.location.href = rootFolder
        return
    }
    // redirect if on loginpage but loggedin (nicht bei Kennungswechsel / Passwort-Reset)
    if ($('#loginpage').length && hasToken && !skipLoggedInRedirect) {
        console.log('Already logged in, redirecting to dashboard')
        window.location.href = './secure/user/index.html'
        return
    }
    // logout action
    $('#logout').on('click', function (e) {
        e.preventDefault()
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        // Cleanup old token keys
        localStorage.removeItem('api')
        localStorage.removeItem('jwt')
        localStorage.removeItem('jwtToken')
        window.location.href = rootFolder
    })
    // populate userprofile
    if (!$('#loginpage').length) {
        var userinfo = JSON.parse(localStorage.getItem('user'))
        if (userinfo && userinfo.user && userinfo.user.attributes) {
            var attrs = userinfo.user.attributes
            var displayName = userinfo.accountName || (attrs.firstName + ' ' + attrs.lastName) || ''
            var accountType = userinfo.accountType || 'MEMBER'
            var accountTypeLabels = { MEMBER: 'Hauptmitglied', LIFE_PARTNER: 'Lebenspartner', REPRESENTATIVE: 'Vertreter' }
            var welcomeName = displayName + '!'
            var accountTypeHintText = ''
            if (accountType === 'LIFE_PARTNER') {
                accountTypeHintText = '(als Lebenspartner angemeldet)'
            } else if (accountType === 'REPRESENTATIVE') {
                accountTypeHintText = '(als Vertreter angemeldet)'
            }
            var dropdownName = displayName
            var nameParts = dropdownName.split(' ')
            $('#userprofile .username').html(nameParts.length > 1 ? nameParts.slice(0, -1).join(' ') + '<br />' + nameParts[nameParts.length - 1] : dropdownName)
            if (attrs.memberNumber && $('#dropdownMemberNumber').length) {
                $('#dropdownMemberNumberValue').text(attrs.memberNumber)
                $('#dropdownMemberNumber').show()
            }
            if (userinfo.thumb) {
                $('#userprofile .userimg').attr("src", "data:image/jpeg;base64, " + userinfo.thumb)
            }
            $('#username').html(welcomeName)
            if ($('#accountTypeWelcomeHint').length && accountTypeHintText) {
                $('#accountTypeWelcomeHint').html('<small class="text-muted" style="font-size: 0.8em">' + accountTypeHintText + '</small>').show()
            } else if ($('#accountTypeWelcomeHint').length) {
                $('#accountTypeWelcomeHint').empty().hide()
            }
            if (userinfo.user.attributes.memberNumber) {
                if ($('#dropdownMemberNumber').length) {
                    $('#dropdownMemberNumberValue').text(userinfo.user.attributes.memberNumber)
                    $('#dropdownMemberNumber').show()
                }
                var welcomeMemberHtml = '<span class="member-number-label">Ihre Mitgliedsnummer:</span> <span id="memberNumberValue">' + userinfo.user.attributes.memberNumber + '</span>'
                $('#welcome #memberNumber').html(welcomeMemberHtml)
            }
            // Account-Typ anzeigen (API 0.8.2: MEMBER, LIFE_PARTNER, REPRESENTATIVE)
            if ($('#accountTypeHint').length && $('#accountTypeLabel').length) {
                $('#accountTypeLabel').text(accountTypeLabels[accountType] || accountType)
                $('#accountTypeHint').show()
            }
        }
    }

    // Set active menu item based on current page and update page title
    setActiveMenuItem()
    updatePageTitleFromMenu()
    
    // Wenn im mobilen Menü ein Link angeklickt wird, Menü schließen
    $('#mobilesidebar').on('click', 'a', function (e) {
        closeNav(e);
    });


    // Get the current year
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    // Find the element with the id "currentYear"
    let currentYearElement = document.getElementById("currentYear");
    // Update the content of the element with the current year
    if (currentYearElement) {
        currentYearElement.textContent = currentYear;
    }
})

/**
 * Sets the active menu item based on the current page URL
 * Automatically detects the current page and highlights the corresponding menu item
 */
function setActiveMenuItem() {
    const currentPath = window.location.pathname
    const currentHash = window.location.hash
    
    // Get the current page filename
    let currentPage = currentPath.split('/').pop() || 'index.html'
    
    // Handle trailing slash or empty filename
    if (!currentPage || currentPage === '' || currentPath.endsWith('/')) {
        currentPage = 'index.html'
    }
    
    // Remove active class from all menu items (both desktop and mobile)
    $('#left .item, #mobilesidebar .item').removeClass('active')
    
    // Find and activate the matching menu item
    $('#left .item a, #mobilesidebar .item a').each(function() {
        const linkElement = $(this)
        const linkHref = linkElement.attr('href')
        
        // Remove query strings and hashes for comparison
        const cleanLink = linkHref.split('?')[0].split('#')[0]
        const cleanCurrent = currentPage.split('?')[0].split('#')[0]
        
        // Direct filename match
        if (cleanLink === cleanCurrent) {
            linkElement.parent('.item').addClass('active')
            return
        }
        
        // Handle index.html specially
        if ((cleanCurrent === 'index.html' || cleanCurrent === '' || currentPath.includes('index.html')) && 
            (cleanLink === 'index.html' || cleanLink === './index.html')) {
            linkElement.parent('.item').addClass('active')
            return
        }
        
        // Check for path-like matches (e.g., "./index.html")
        if (cleanLink === './' + cleanCurrent) {
            linkElement.parent('.item').addClass('active')
            return
        }
    })
}

/**
 * Updates the page title based on the active menu item
 * Extracts the menu item text and adds it to the document title
 */
function updatePageTitleFromMenu() {
    const activeMenuItem = $('#left .item.active, #mobilesidebar .item.active')
    
    //console.log('Active menu items found:', activeMenuItem.length)
    //console.log('Current document title:', document.title)
    
    // Always set a fresh title to avoid duplication
    if (activeMenuItem.length > 0) {
        // Take only the first active menu item
        const menuText = $(activeMenuItem[0]).find('a').text().trim()
        
        //console.log('Menu text extracted:', menuText)
        
        if (menuText) {
            // Update document title with format: "Menu Item - HILO Mitgliederportal"
            const newTitle = menuText + ' - HILO Mitgliederportal'
            document.title = newTitle
            //console.log('Title updated to:', newTitle)
        }
    } else {
        // Fallback title if no active menu item found
        document.title = 'HILO Mitgliederportal'
        //console.log('Fallback title set')
    }
}
